var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { SUP_URL, SupportLink } from '@devdept/sup-js';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { ymReachGoal } from '../../../../helpers/common';
import { YM_GOALS_NAV } from './constants';
import { Menu } from './styled';
var SupPath = 'sup.samoletgroup.ru';
var RriPath = 'rri.samoletgroup.ru';
var SrmProposalsPath = 'srmproposals.samoletgroup.ru';
var NavigationMenu = function (_a) {
    var mode = _a.mode, loading = _a.loading, username = _a.username, defaultMenu = _a.defaultMenu, supportLinkProps = _a.supportLinkProps, withSupportLink = _a.withSupportLink;
    var location = useLocation();
    var _b = __read(useState(defaultMenu), 2), menu = _b[0], setMenu = _b[1];
    useEffect(function () {
        if (defaultMenu.length) {
            var newMenu = defaultMenu
                .map(function (page) {
                if (typeof page.path === 'string' &&
                    (page.path.includes(RriPath) || page.path.includes(SrmProposalsPath))) {
                    var newUrl = new URL(page.path);
                    newUrl.searchParams.set('backlink', encodeURIComponent(window.location.href));
                    page.path = newUrl.toString();
                }
                return page;
            });
            if (withSupportLink) {
                setMenu(newMenu.filter(function (page) { return !page.path.includes(SupPath); }));
            }
            else {
                setMenu(newMenu);
            }
        }
    }, [defaultMenu, location, withSupportLink]);
    var handleClick = useCallback(function (path, onClick) {
        if (onClick === void 0) { onClick = function () { }; }
        return function () {
            ymReachGoal(YM_GOALS_NAV[path]);
            onClick === null || onClick === void 0 ? void 0 : onClick();
        };
    }, []);
    if (loading)
        return null;
    return (React.createElement(Menu, { mode: mode, getPopupContainer: function (trigger) { return trigger.parentElement || document.body; } },
        withSupportLink && username && (React.createElement(Menu.Item, { onClick: handleClick(SUP_URL) },
            React.createElement(SupportLink, __assign({}, supportLinkProps, { username: username })))),
        menu.map(function (_a, i) {
            var title = _a.title, exact = _a.exact, cards = _a.cards, path = _a.path, to = _a.to, onClick = _a.onClick, item = __rest(_a, ["title", "exact", "cards", "path", "to", "onClick"]);
            return (React.createElement(Menu.Item, __assign({ key: i }, item, { onClick: handleClick(to, onClick) }),
                React.createElement("a", { href: path }, title)));
        })));
};
export { NavigationMenu };
//# sourceMappingURL=NavigationMenu.js.map